module.exports = __webpack_public_path__ + "img/arrow-left-right.160719e6.svg";